/**
 * Focuses and scrolls to the first field with `aria-invalid="true"`.
 *
 * Returns whether it found one. A caller that got `false` has an invalid form
 * with nothing on screen to point at — a field inside a closed sheet, say — and
 * owes the author a message of its own, or the refusal reads as a dead button.
 */
export function focusFirstInvalid(): boolean {
  const el = document.querySelector('[aria-invalid="true"]') as HTMLElement | null;
  if (!el) return false;
  el.focus({ preventScroll: false });
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  return true;
}
